import React from "react";
import "./HousekeepingServices.css";

// 👉 Replace with your own small icon
import ServiceIcon from "../../Image/HouseKeeping/rightthick.png";

const services = [
  "Housekeeping",
  "Pantry",
  "Technicians",
  "Loaders",
  "Office boys",
  "Supervisors",
  "Front-office executives",
  "Runners",
  "Admin Managers",
  "Facility Executives, Facility Managers",
  "Sales & Marketing Personnel",
 
];

const steps = [
  {
    number: "01",
    title: "Requirement Analysis",
    desc: "Understand your staffing needs, skill requirements, and operational workflow",
  },
  {
    number: "02",
    title: "Recruitment & Verification",
    desc: "Source qualified candidates, conduct verification, and complete documentation",
  },
  {
    number: "03",
    title: "Training & Deployment",
    desc: "Provide job-specific training and deploy personnel to your facility",
  },
  {
    number: "04",
    title: "Ongoing Management",
    desc: "Handle payroll, compliance, supervision, and performance management.",
  },
];

const ManpowerServices = () => {
  return (
    <>
      {/* ---------------- SERVICES SECTION ---------------- */}
      <section className="hk-services-section">
        <h2 className="hk-section-title">Our Service Includes</h2>

        <div className="hk-services-grid">
          {services.map((item, index) => (
            <div key={index} className="hk-service-card">
              <img src={ServiceIcon} alt="service" className="hk-service-img" />
              <span>{item}</span>
            </div>
          ))}
        </div>
      </section>

      {/* ---------------- PROCESS SECTION ---------------- */}
      <section className="hk-process-section">
        <div className="hk-process-tag">Our Process</div>
        <h2 className="hk-section-title">Our Staffing Process</h2>

        <div className="hk-process-grid">
          {steps.map((step, index) => (
            <div key={index} className="hk-process-card">
              <div className="hk-process-number">{step.number}</div>
              <h4>{step.title}</h4>
              <p>{step.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default ManpowerServices;
